/* eslint-disable react/destructuring-assignment */
import React, { useContext, useState } from "react";
import { string, shape, instanceOf, bool, func } from "prop-types";
import { selectors as sessionSelectors } from "reducers/session";
import { store } from "store";
import { TransactionContext } from "pages/_components/TransactionCard/TransactionContext";
import { useAccount } from "hooks/useAccounts";
import Loader from "pages/_components/Loader";
import * as i18n from "util/i18n";
import moment from "moment";
import { isEmpty } from "lodash";
import FormattedAmount from "pages/_components/FormattedAmount";
import CustomData from "pages/_components/CustomData/CustomData";
import Image from "pages/_components/Image";
import Button from "pages/_components/Button";
import { TransactionSign } from "pages/_components/TransactionCard";
import GridTable from "pages/_components/GridTable/GridTable";

const EmitEchekSummaryBody = (props) => {
    const { transaction = {} } = useContext(TransactionContext);
    const [buttonLabel, setButtonLabel] = useState("echecks.seeMore.button");
    const username = sessionSelectors.getUserFullName(store.getState());
    const { data = {}, creationDateTime = moment(), idTransaction = "" } = transaction;
    const {
        beneficiary = props.beneficiary.document,
        beneficiaryName = props.beneficiary.reference,
        echeqsToEmit = props.echeqsToEmit,
        mode = props.mode,
        character = props.character,
        concept = props.concept,
        motive = props.motive,
        amount = { currency: "ARS", quantity: 0 },
        environmentCuit = "",
        emittedEcheqs = {},
        idAccount = props.idAccount,
        ticket = props.ticket,
        echeqNumeration = props.echeqNumeration,
        isFinished = props.isFinished,
        showMoreData = props.showMoreData,
        setShowMoreData = props.setShowMoreData,
        isDesktop = props.isDesktop,
    } = data;
    const echeqNumerationObj = echeqNumeration && JSON.parse(echeqNumeration);
    const beneficiaryArr = data?.beneficiary?.split(" ");
    const beneficiaryCuit = beneficiaryArr && beneficiaryArr[1];
    const { fetching, account } = useAccount("productId", idAccount);

    const emisionFormated = `····${account?.accountNumber?.slice(-4)} ${account?.accountType} ${i18n.get(
        `currency.label.${account?.currency}`,
    )}`;
    const conceptFormatted = i18n.get(`transfer.reasons.${concept}`);

    if (fetching) {
        return <Loader />;
    }

    const handleSeeMoreData = () => {
        setShowMoreData(!showMoreData);
        if (!showMoreData) {
            setButtonLabel("echecks.seeLess.button");
        } else {
            setButtonLabel("echecks.seeMore.button");
        }
    };
    if (ticket) {
        return (
            <>
                <div className="ticket__body ticket__full-width echeq-emit">
                    <div className="echeq">
                        <div className="data-personal">
                            <div className="logo">
                                <Image src="images/logoCompany.svg" />
                            </div>
                            <CustomData
                                dataClass="benefitiary"
                                titleText="echecks.beneficiary"
                                titleTextType="I18N"
                                valueText={beneficiaryName}
                            />
                            <div className="cuit">{beneficiary}</div>
                        </div>
                        <div className="data-dates">
                            <CustomData
                                dataClass="date-emision"
                                titleText="echecks.createdRange.label"
                                titleTextType="I18N"
                                valueText={creationDateTime}
                                valueTextType="DATE"
                            />
                            <CustomData
                                dataClass="date-pay"
                                titleText="echecks.payedRange.label"
                                titleTextType="I18N"
                                valueText={echeqsToEmit[0]?.date}
                                valueTextType="DATE"
                            />
                        </div>
                        {isDesktop && <div className="vertical-divider"> </div>}
                        <div className="data-tags">
                            {isFinished && (
                                <div className="echeq-number number">
                                    Echeq {echeqNumerationObj?.[0]?.cheque_numero}
                                </div>
                            )}
                            <div className="tag tag-error character">{character}</div>
                            <CustomData
                                dataClass="tag tag-echeq-character amount-desktop amount tag tag-warning"
                                titleClass="text-right"
                                titleText="echecks.amount"
                                titleTextType="I18N"
                                valueText={
                                    <FormattedAmount
                                        className="data-label"
                                        currency={amount.currency}
                                        quantity={echeqsToEmit[0]?.amount}
                                    />
                                }
                            />
                        </div>
                        <div className="amount-mobile">
                            <div className="horizontal-divider divider_1" />
                            <CustomData
                                dataClass="amount tag tag-warning"
                                titleText="echecks.amount"
                                titleTextType="I18N"
                                valueText={
                                    <FormattedAmount
                                        className="data-label"
                                        currency={amount.currency}
                                        quantity={echeqsToEmit[0]?.amount}
                                    />
                                }
                            />
                        </div>
                    </div>
                    <div className="view-more-data-button" id="element-to-ignore">
                        <div className="ticket__divider divider_1 inside-ticket__body">
                            <div className="ticket__notch ticket__notch--left"> </div>
                            <div className="ticket__notch ticket__notch--right"> </div>
                        </div>
                        <Button
                            aria-expanded={showMoreData ? "true" : "false"}
                            className="more-button no-print"
                            label={buttonLabel}
                            bsStyle="link"
                            onClick={handleSeeMoreData}
                            image={showMoreData ? "figma/icon/arrow-up.svg" : "figma/icon/arrow-down.svg"}
                        />
                    </div>
                    <div className={`view-more-data ${showMoreData ? "expand " : "collapse"}`}>
                        <div className="emissor-beneficiary">
                            <div className="emissor-data">
                                <h2>{i18n.get("echecks.emissor", "Emisor")}</h2>
                                <CustomData
                                    dataClass="benefitiary"
                                    titleText="echeqs.emit.reference.socialdenomination"
                                    titleTextType="I18N"
                                    valueText={username}
                                />
                                <CustomData
                                    dataClass=""
                                    titleText="echecks.document"
                                    titleTextType="I18N"
                                    valueText={environmentCuit}
                                />
                                <CustomData
                                    dataClass=""
                                    titleText="echecks.emit.emision.label"
                                    titleTextType="I18N"
                                    valueText={emisionFormated}
                                />
                            </div>
                            <div className="benefitiary-data">
                                <h2 className="">{i18n.get("echecks.beneficiary")}</h2>
                                <CustomData
                                    dataClass=""
                                    titleText="echeqs.emit.reference.socialdenomination"
                                    titleTextType="I18N"
                                    valueText={beneficiaryName}
                                />
                                <CustomData
                                    dataClass=""
                                    titleText="echecks.document"
                                    titleTextType="I18N"
                                    valueText={beneficiaryCuit}
                                />
                                <CustomData
                                    dataClass=""
                                    titleText=" "
                                    titleTextType="text"
                                    valueText=" "
                                    valueTextType="text"
                                />
                            </div>
                        </div>
                        {!isDesktop && <div className="ticket__divider divider_2 inside-ticket__body">
                            <div className="ticket__notch ticket__notch--left"> </div>
                            <div className="ticket__notch ticket__notch--right"> </div>
                        </div>}
                        <div className="aditional-data">
                            <h2>{i18n.get("", "Datos adicionales")}</h2>
                            <CustomData
                                dataClass="echeq-concept"
                                titleText="echecks.emit.motive.label"
                                titleTextType="I18N"
                                valueText={motive}
                            />

                            <CustomData
                                dataClass="echeq-reference"
                                titleText="echecks.emit.reference.label"
                                titleTextType="I18N"
                                valueText={echeqsToEmit[0]?.reference || "-"}
                                valueTextType="TEXT"
                            />
                            <CustomData
                                dataClass="echeq-emitmode"
                                titleText="echecks.echeckConcept"
                                titleTextType="I18N"
                                valueText={conceptFormatted}
                                valueTextType="TEXT"
                            />
                            <CustomData
                                dataClass=""
                                titleText="echecks.cmc7"
                                titleTextType="I18N"
                                valueText={echeqNumerationObj ? echeqNumerationObj[0].cmc7 : "-"}
                                valueTextType="TEXT"
                            />
                        </div>
                        {isDesktop && <div className="ticket__divider divider_1 inside-ticket__body">
                            <div className="ticket__notch ticket__notch--left"> </div>
                            <div className="ticket__notch ticket__notch--right"> </div>
                        </div>}
                        <div className="signatures-data">
                            <TransactionSign
                                noDate
                                creationTime
                                isSmall
                                isFinished
                                hasSignatures
                                customText="forms.transaction.ticket.dateAndHour"
                                isDesktop={isDesktop}
                                showMoreData={showMoreData}
                            />
                        </div>
                    </div>
                </div>
            </>
        );
    }
    return (
        <GridTable className="details echeq-emit echeq-emit-list">
            <GridTable.Container columns={isDesktop ? 5 : 2}>
                <GridTable.Data columnStart={1} rowStart={1} columnWidth={1}>
                    {idTransaction && (
                        <>
                            <CustomData
                                titleText="ticket.voucher"
                                titleTextType="I18N"
                                valueText={idTransaction.substring(0, 8).toUpperCase()}
                            />
                            <CustomData titleText="echecks.cuit" titleTextType="I18N" valueText={environmentCuit} />
                            {!isEmpty(emittedEcheqs) && (
                                <CustomData
                                    titleText="echecks.number.label"
                                    titleTextType="I18N"
                                    valueText={Object.keys(emittedEcheqs)[0]}
                                    valueTextType="TEXT"
                                />
                            )}
                        </>
                    )}
                    <CustomData
                        titleText="echecks.emit.emision.label"
                        titleTextType="I18N"
                        valueText={emisionFormated}
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={isDesktop ? 5 : 2} rowStart={1} columnWidth={1} alignX="flex-end">
                    <div className="tag tag-success">{character}</div>
                </GridTable.Data>

                <GridTable.Data columnStart={1} rowStart={2} columnWidth={1}>
                    <CustomData
                        titleText="echecks.createdRange.label"
                        titleTextType="I18N"
                        valueText={creationDateTime}
                        valueTextType="DATE"
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={2} rowStart={2} columnWidth={1}>
                    <CustomData
                        titleText="echecks.payedRange.label"
                        titleTextType="I18N"
                        valueText={echeqsToEmit[0]?.date}
                        valueTextType="DATE"
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={isDesktop ? 3 : 1} rowStart={isDesktop ? 2 : 3} columnWidth={isDesktop ? 1 : 2}>
                    <CustomData titleText="echecks.emit.mode" titleTextType="I18N" valueText={mode} />
                </GridTable.Data>
                <GridTable.Data columnStart={isDesktop ? 1 : 2} rowStart={3} columnWidth={1}>
                    <CustomData
                        titleText="echecks.echeckConcept"
                        titleTextType="I18N"
                        valueText={conceptFormatted}
                        valueTextType="TEXT"
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 3 : 4} columnWidth={1}>
                    <CustomData
                        titleText="echecks.emit.motive.label"
                        titleTextType="I18N"
                        valueText={motive || "-"}
                        valueTextType="TEXT"
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={isDesktop ? 3 : 2} rowStart={isDesktop ? 3 : 4} columnWidth={1}>
                    <CustomData
                        titleText="echecks.emit.reference.label"
                        titleTextType="I18N"
                        valueText={echeqsToEmit[0]?.reference || "-"}
                        valueTextType="TEXT"
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={1} rowStart={isDesktop ? 4 : 5} columnWidth={isDesktop ? 5 : 2} className="horizontal-divider m-0">
                    {" "}
                </GridTable.Data>
                {isDesktop &&
                    <GridTable.Data columnStart={4} rowStart={1} columnWidth={1} rowWidth={3} className="vertical-divider">
                        {" "}
                    </GridTable.Data>
                }
                <GridTable.Data columnStart={isDesktop ? 5 : 1} rowStart={isDesktop ? 2 : 7} columnWidth={1} alignX={isDesktop ? "right" : "left"}>
                    <CustomData
                        titleText="echecks.echeckType"
                        titleTextType="I18N"
                        valueText={echeqsToEmit[0]?.type}
                        valueTextType="TEXT"
                        dataClass={isDesktop && "items-end"}
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={isDesktop ? 5 : 2} rowStart={isDesktop ? 3 : 7} columnWidth={1} alignX={isDesktop ? "right" : "left"}>
                    <CustomData
                        titleText="echecks.amount"
                        titleTextType="I18N"
                        dataClass={isDesktop && "items-end"}
                        valueText={
                            <FormattedAmount
                                className="data-label"
                                currency={amount.currency}
                                quantity={echeqsToEmit[0]?.amount}
                            />
                        }
                    />
                </GridTable.Data>
                {!isDesktop &&
                    <GridTable.Data columnStart={1} rowStart={8} columnWidth={2} className="horizontal-divider m-0">
                        {" "}
                    </GridTable.Data>
                }

                <GridTable.Data columnStart={1} rowStart={isDesktop ? 5 : 9} columnWidth={isDesktop ? 5 : 2}>
                    <h2>{i18n.get("echecks.beneficiary")}</h2>
                </GridTable.Data>
                <GridTable.Data columnStart={1} rowStart={isDesktop ? 6 : 10} columnWidth={1}>
                    <CustomData titleText="echeqs.emit.reference.socialdenomination" titleTextType="I18N" valueText={beneficiaryName} />
                </GridTable.Data>
                <GridTable.Data columnStart={2} rowStart={isDesktop ? 6 : 10} columnWidth={1}>
                    <CustomData titleText="echecks.document" titleTextType="I18N" valueText={beneficiary} />
                </GridTable.Data>
            </GridTable.Container>
        </GridTable>
    );
};

EmitEchekSummaryBody.propTypes = {
    idAccount: string,
    beneficiary: shape({
        reference: string,
        document: string,
    }),
    echeqsToEmit: instanceOf(Array),
    mode: string,
    character: string,
    concept: string,
    motive: string,
    reference: string,
    ticket: bool,
    echeqNumeration: string,
    isFinished: bool,
    showMoreData: bool,
    isDesktop: bool,
    setShowMoreData: func,
};

EmitEchekSummaryBody.defaultProps = {
    idAccount: "",
    beneficiary: {
        reference: "",
        document: "",
    },
    echeqsToEmit: [],
    mode: "",
    character: "",
    concept: "",
    motive: "-",
    reference: "-",
    ticket: false,
    echeqNumeration: "",
    isFinished: false,
    showMoreData: false,
    isDesktop: false,
    setShowMoreData: () => { },
};

export default EmitEchekSummaryBody;
